function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../../../../develop/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2b6ad9df\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=styles&index=0!./Unpaid.vue")
}
var Component = require("!../../../../../../develop/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../develop/node_modules/vue-loader/lib/selector?type=script&index=0!./Unpaid.vue"),
  /* template */
  require("!!../../../../../../develop/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2b6ad9df\",\"hasScoped\":true}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=template&index=0!./Unpaid.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b6ad9df",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/Unpaid.vue
// module id = 407
// module chunks = 0